<legend [class]="'govuk-fieldset__legend ' + classes">
  <ng-content></ng-content>
</legend>
